// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2WJOq","fileBtn":"File_fileBtn__37-7B","closeBtn":"File_closeBtn__nFiCp","fileSelected":"File_fileSelected__1ubsr","disabled":"File_disabled__3KzdI"};